import React from 'react';

const formatCPF = (cpf) => {
  if (!cpf) return '-';
  const cleaned = cpf.replace(/\D/g, '');
  if (cleaned.length !== 11) return cpf;
  return cleaned.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
};

export const getMotoristaColumns = () => [
  {
    id: 'nome',
    header: 'Nome',
    accessorKey: 'Nome',
    size: 300,
    enableSorting: true,
    cell: ({ getValue }) => getValue() || '-',
  },
  {
    id: 'cpf',
    header: 'CPF',
    accessorKey: 'Cpf',
    size: 150,
    enableSorting: true,
    cell: ({ getValue }) => formatCPF(getValue()),
  },
  {
    id: 'codigoIntegracao',
    header: 'Código Integração',
    accessorKey: 'CodigoIntegracao',
    size: 200,
    enableSorting: true,
    cell: ({ getValue }) => getValue() || '-',
  },
  {
    id: 'tipo',
    header: 'Tipo',
    accessorKey: 'Tipo',
    size: 150,
    enableSorting: true,
    cell: ({ getValue }) => getValue() || '-',
  },
];
